import { theme } from "@chakra-ui/core";

const breakpoints = ["360px", "768px", "1024px", "1541px"];
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];

const customTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    brand: {
      50: "#feffda",
      100: "#fffaad",
      200: "#fff27d",
      300: "#ffe64b",
      400: "#ffd71a",
      500: "#e6b600",
      600: "#b39a00",
      700: "#807600",
      800: "#4e4c00",
      900: "#1d1b00",
    },
    breakpoints,
  },
  fonts: {
    body: "Museo Sans, sans-serif",
    heading: "Familiar Pro",
    fontSize: "18px",
  },
};

export default customTheme;
